window.scrollTo = function(element, speed){
    var speed = speed > 0 ? speed : 400;
    if(typeof element === "string"){
        element = $(element);
        if(element.length === 0){
            return false;
        }
    }
    $('html, body').animate({
        scrollTop: element.offset().top - $('.header').outerHeight()
    }, speed);
};

jQuery(document).ready(function(){
    var body = $('body');
    var navOpenedClass = 'mobile-nav-opened';

    body.on('click', '.toggle-mobile-nav', function(e){
        e.preventDefault();
        if(!body.hasClass(navOpenedClass)){
            body.addClass(navOpenedClass)
        } else {
            body.removeClass(navOpenedClass);
        }
    }).on('click', '[data-toggle="scroll"]', function(e){
        if((jQuery(this).data('scroll') && jQuery(jQuery(this).data('scroll')).length !== 0 ) || jQuery(jQuery(this).attr('href')).length !== 0){
            e.preventDefault();
            body.removeClass(navOpenedClass);

            if(jQuery(this).data('scroll'))
                window.scrollTo(jQuery(this).data('scroll'));
            else
                window.scrollTo($(this).attr('href'));
        }

    });
}); // end document ready event
